export const FLATTEN_CATEGORY = [
  'space',
  'breakpoints',
  'borderRadius',
  'main'
];
